import React from 'react';
import { Gift, AlertTriangle } from 'lucide-react';
const bonuses = [{
  number: 1,
  title: 'PAKIET STARTOWY 15 MINUT',
  description: 'Kompletna checklista przed każdymi zajęciami. Żeby każda sesja przebiegała sprawnie od pierwszej minuty.',
  value: '160 zł'
}, {
  number: 2,
  title: '52 GOTOWE ROZGRZEWKI',
  description: '52 gotowe rozgrzewki na cały rok dla wszystkich poziomów U12–U18. Koniec z pustą głową przed lekcją.',
  value: '160 zł'
}, {
  number: 3,
  title: 'ARKUSZE BŁYSKAWICZNEJ OCENY',
  description: 'Profesjonalny system kontroli jakości zajęć. Wszystko pod kontrolą od pierwszego gwizdka do ostatniego.',
  value: '160 zł'
}, {
  number: 4,
  title: 'PAKIET AWARYJNY: BRAK HALI',
  description: 'Gotowe rozwiązania na dni gdy warunki się sypią. Koniec z chaosem w deszczowe dni.',
  value: '160 zł'
}, {
  number: 5,
  title: '101 KOMEND TRENERA',
  description: '101 gotowych komend które organizują grupę i budują Twój autorytet na sali natychmiast.',
  value: '160 zł'
}, {
  number: 6,
  title: 'CHECKLISTA TURNIEJU',
  description: 'Gotowe formaty, tabele meczów i certyfikaty. Zorganizuj turniej w 1 godzinę.',
  value: '160 zł'
}];
export function Bonuses() {
  return <section className="w-full bg-cream-alt py-12 md:py-20 px-4 md:px-6" data-id="element-59">
      <div className="max-w-6xl mx-auto" data-id="element-60">
        <div className="text-center mb-8 md:mb-12" data-id="element-61">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-white mb-3 md:mb-4" data-id="element-62">
            6 specjalnych bonusów w pakiecie
          </h2>
          <p className="text-xl md:text-2xl text-gold-accent font-bold" data-id="element-63">
            Łączna wartość bonusów: 960 zł
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-64">
          {bonuses.map((bonus, index) => <div key={index} className="bg-[#1A3257] rounded-2xl p-5 md:p-6 shadow-lg border border-[#1E3A5F] flex flex-col h-full relative overflow-hidden" data-id="element-65">
              <div className="flex flex-col sm:flex-row items-start gap-4 h-full" data-id="element-66">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-gold-accent/10 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-67">
                  <Gift className="w-5 h-5 md:w-6 md:h-6 text-gold-accent" data-id="element-68" />
                </div>
                <div className="flex-1 flex flex-col h-full" data-id="element-69">
                  <div className="flex flex-wrap justify-between items-start gap-2 mb-2" data-id="element-70">
                    <h3 className="font-display font-bold text-white text-base md:text-lg pr-2" data-id="element-71">
                      BONUS {bonus.number} — {bonus.title}
                    </h3>
                    <span className="bg-gold-accent text-[#0A1628] px-2.5 py-0.5 rounded-full text-xs font-bold whitespace-nowrap" data-id="element-72">
                      {bonus.value} GRATIS
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-[#E8EAF0] leading-relaxed flex-grow" data-id="element-73">
                    {bonus.description}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-8 md:mt-10 flex justify-center" data-id="element-74">
          <div className="inline-flex items-start sm:items-center gap-3 px-5 py-3 md:px-6 md:py-4 rounded-xl border max-w-2xl" style={{
          background: 'rgba(230, 57, 70, 0.1)',
          borderColor: '#E63946'
        }} data-id="element-75">
            <AlertTriangle className="w-5 h-5 md:w-6 md:h-6 flex-shrink-0 mt-0.5 sm:mt-0" style={{
            color: '#E63946'
          }} data-id="element-76" />
            <p className="font-bold text-sm md:text-base leading-snug" style={{
            color: '#E8EAF0'
          }} data-id="element-77">
              Bonusy dostępne wyłącznie przy zakupie w tej ofercie startowej
            </p>
          </div>
        </div>
      </div>
    </section>;
}